import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login, logout } from '../../redux/slices/authSlice';
import SignIn from './Signin';
import ResetPwd from './ResetPwd';
import loginLogo from '../../assets/login-logo.svg';

// 登录页负责承载页面视觉布局，并控制登录与忘记密码表单切换。
export default function Login() {
  const [mode, setMode] = useState('signin'); // 'signin' | 'reset'
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, []);

  // 切换登录与重置密码模式，保留原有过渡动画。
  const switchMode = (newMode) => {
    setIsAnimating(true);
    setTimeout(() => {
      setMode(newMode);
      setTimeout(() => setIsAnimating(false), 50);
    }, 200);
  };

  // 登录成功后同步用户状态并跳转到业务首页。
  const handleLoginSuccess = (userInfo) => {
    // 更新 Redux 状态
    dispatch(login(userInfo));
    // 跳转到首页
    navigate('/booth');
  };

  // 重置密码成功后回到登录表单。
  const handleResetSuccess = () => {
    // 重置成功后返回登录
    switchMode('signin');
  };

  return (
    <div
      className="relative h-screen w-screen overflow-hidden bg-[#f9f9f9] text-[#333]"
      style={{
        backgroundImage: `url('https://statics.dronex.cc/run/loginbg.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <nav className="absolute left-0 top-0 z-40 flex h-[60px] w-full items-center justify-between bg-[#191919] px-[21px]">
        <div className="flex h-full items-center">
          <div className="inline-flex h-[38px] items-center justify-start">
            <img
              src={loginLogo}
              alt="赛事平台"
              className="h-full w-auto object-contain"
            />
            <span className="ml-[13px] flex h-[33px] items-center border-l border-white/30 pl-[22px] text-[24px] leading-6 text-white">
              跑酷及障碍跑赛事管理系统
            </span>
          </div>
        </div>

        {/* <a
          href="https://www.dronex.cc/"
          target="_blank"
          rel="noreferrer"
          className="border-b border-[#1958ff] pb-0.5 text-[16px] leading-9 text-[#1958ff] transition-opacity hover:opacity-80"
          aria-label="访问官网"
        >
          官网 &gt;
        </a> */}
      </nav>

      <div className="absolute left-[100px] top-[calc(60px_+_(100%_-_60px_-_156px)_/_2)] z-20 hidden h-[156px] w-[108px] flex-col items-center rounded-[6px] bg-white px-[12px] pt-[14px] text-center text-[12px] leading-[18px] text-[#333] shadow-sm xl:flex">
        <img
          src="https://statics.dronex.cc/qrcode/run/miniqr.jpg"
          alt="小程序二维码"
          className="h-[80px] w-[80px] object-cover"
        />
        <span className="mt-[18px]">SporsX跑酷小程序</span>
        <span>手机扫码进入</span>
      </div>

      <main className="absolute left-0 top-[60px] z-10 flex h-[calc(100%_-_60px)] w-full flex-col items-center">
        <div className="flex min-h-0 w-full flex-1 items-center justify-center">
          <div className="text-center">
            <h1 className="text-[48px] font-normal text-[#333]">
              轻松办赛&nbsp;&nbsp;赛事大麦
            </h1>
            <p className="text-[24px] font-normal text-[#999]">
              智能规划&nbsp;塑造品牌&nbsp;助力经营
            </p>
          </div>
        </div>

        <div className="h-[320px] w-[450px] shrink-0 rounded-[18px] bg-white px-8 pb-[37px] pt-[44px] shadow-[0_2px_13px_0_rgba(0,0,0,0.1)]">
          <div
            className={`transition-all duration-300 ${
              isAnimating
                ? 'opacity-0 translate-x-4'
                : 'opacity-100 translate-x-0'
            }`}
          >
            {mode === 'signin' ? (
              <SignIn
                onSuccess={handleLoginSuccess}
                onForgotPassword={() => switchMode('reset')}
              />
            ) : (
              <ResetPwd
                onSuccess={handleResetSuccess}
                onBack={() => switchMode('signin')}
              />
            )}
          </div>
        </div>

        <div className="flex min-h-0 w-full flex-1 items-center justify-center">
          <p className="text-center text-[14px] leading-[30px] text-[#333]">
            © SporsX 2025 版权所有&nbsp;&nbsp;&nbsp;粤ICP备2025476630号-1
          </p>
        </div>
      </main>
    </div>
  );
}
